import gql from "graphql-tag";

const query = gql`
  query Contract($contractId: ID) {
    contract(contractId: $contractId) {
      id
      ownedByPartnerId
      name
      description
      customer {
        id
        description
      }
      deploymentId
      deployment {
        id
        codename
      }
      monthlyTiiviiHours
      keepVideosForMonths
      allowedMasterStreamSave
      allowedProductionTypes {
        id
        name
        description
      }
      allowedIAAlgorithms {
        id
        name
        description
      }
      allowedEventTypes {
        id
        name
        description
      }
      liveCommentatorSupport
      bannerSupport
      scoreboardSupport
      tiiviiOttConfig {
        enabled
        webhookUrl
        nimbleConfigUrl
      }
    }
  }
`;

export default contractId => ({
  query,
  variables: { contractId },
});
